import React, { useRef } from "react";
import ListPageHeader from "../utilities/ListPageHeader";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Stack,
  Tab,
  Tabs,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CustomDatePicker from "../utilities/CustomDatePicker";
import AgGridTable from "../utilities/AgGridTable";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import { useState } from "react";
import ReconciliationGrid from "./ReconciliationGrid";
import StatementOfNOLTE from "./StatementOfNOLTE";
import { useNavigate } from "react-router-dom";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import moment from "moment";
import { useEffect } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import jwtDecode from "jwt-decode";

const Reconciliation = () => {
  const gridRef = useRef();
  const childRef = useRef();
  const reconRef = useRef();
  const [fromError, setFromError] = useState();
  const [toError, setToError] = useState();
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [successMsg, setSuccessMsg] = useState();
  const [snackState, setSnackState] = useState(false);
  const [error, setError] = useState();
  const [tabValue, setTabValue] = useState(0);
  const [gridApi, setGridApi] = useState();
  const [formOpen, setFormOpen] = useState(false);
  const [uploadDisabled, setUploadDisabled] = useState(false);
  const [vendor, setVendor] = useState();
  const navigate = useNavigate();
  const [invoiceNoRowData, setinvoiceNoRowData] = useState([]);
  const [documentUpload, setDocumentUpload] = useState();
  const [documentFile, setDocumentFile] = useState(null);
  const [matchInvoice, setMatchInvoice] = useState();
  
  const showFixedValue = (props) => {
    const options = {
      style: "decimal", // Other options: 'currency', 'percent', etc.
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
    return (
      <span>
        <p>
          {props?.value
            ? Number(props?.value).toLocaleString("en-US", options)
            : 0.0}
        </p>
      </span>
    );
  };

  const handleDateFormat = (props) => {
    return props?.value && moment(props?.value).format('DD-MM-YYYY')
  }
  
  const [invoiceNoColumnDefs, setInvoiceNoColumnDefs] = useState([
    { field: "invoiceNo", headerName: "Invoice No" },
    { field: "invoiceDate", headerName: "Date of invoice", cellRenderer: handleDateFormat },
    { field: "invoiceAmount", headerName: "Amount", cellRenderer:showFixedValue },
    { field: "ab_no", headerName: "AB No" },
    { field: "due", headerName: "Due" },
    { field: "docDescription", headerName: "Description" },
    // { field: "invoice_no", headerName: "Invoice No" },
  ]);
  const [bankOpen, setBankOpen] = useState(false);
  const LedgerURL = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.voucher}`;
  const ReconciliationURL = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.reconciliation}`;
  const token =
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));

  const handlePrintReconcilitation = async () => {
    const printReconcile = await OAuthService.getDownload(
      ReconciliationURL +
        "/printReconciliation" +
        `?dateFrom=${fromDate}&dateTo=${toDate}`
    );
    const blob = printReconcile?.data;
    if (blob) {
      const url = window.URL.createObjectURL(
        new Blob([blob], { type: "application/octet-stream" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.download = "Reconcile.xlsx";
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  };

  const handleReconcile = async () => {
    // const matchingInvoices = await OAuthService.getList(ReconciliationURL + '/getMatchingInvoicesFromUnpaidList',  );
    // setMatchInvoice(matchingInvoices);
  };

  const handleUploadReconcilitation = () => {
    setDocumentUpload();
    setDocumentFile("");
    setFormOpen(true);
    setUploadDisabled(false);
  };

  const handleFormClose = () => {
    setFormOpen(false);
  };

  const handleFromDateChange = (value) => {
    setFromDate(value === null ? null : moment(value).format("YYYY-MM-DD"));
    value && setToDate(null);
    loadLedgerListData(
      value === null ? null : moment(value).format("YYYY-MM-DD"),
      value ? moment(new Date()).format("YYYY-MM-DD") : toDate
    );
  };

  const handleToDateChange = (value) => {
    const endDate = value === null ? null : moment(value).format("YYYY-MM-DD");
    setToDate(endDate);
    !fromDate && endDate
      ? setFromError("Please select from date ")
      : setFromError("");
    loadLedgerListData(fromDate, endDate);
  };

  const handleTabChange = (event, value) => {
    setTabValue(value);
  };

  const handleSaveReconcilition = (event) => {
    const reconElement = reconRef.current;
    reconElement?.saveReconcilition(event);
  };

  const handleRefreshReconcile = async (event, value) => {
    const reconElement = reconRef.current;
    reconElement?.handleRefreshReconcile(event, fromDate,toDate);
  };

  const handleAddReconcilitation = (event, value) => {};

  const handleDocumentChange = (e) => {
    const file = e.target.files[0];
    setDocumentUpload(file.name);
    setDocumentFile(file);
  };

  const importExcel = (event) => {
    setUploadDisabled(true);
    const childElement = childRef.current;
    childElement?.importExcel(event);
    handleFormClose();
  };

  const handleSuccessMsg = (msg) => {
    if (msg) {
      setSuccessMsg(msg);
      setSnackState(true);
    } else {
      setSnackState(false);
    }
  };

  const loadLedgerListData = async (fromDates, toDates) => {
    try {
      if (
        token?.scope?.includes("ROLE_FINANCE") ||
        token?.scope?.includes("ROLE_FINMGR") ||
        token?.scope?.includes("ROLE_SOPDIR")
      ) {
        let searchObj = { };
        if (fromDates)
          searchObj = {
            ...searchObj,
            startDate: moment(fromDates).format("YYYY-MM-DD"),
          };
        if (toDates) {
          searchObj = {
            ...searchObj,
            endDate: moment(toDates).format("YYYY-MM-DD"),
          };
        }
        const loadData = await OAuthService.addData(
          LedgerURL + "/searchVoucher",
          searchObj
        );
        let list = loadData?.data.map((data) => {
          data.voucherType = data?.voucherType?.shortKey;
          return data;
        });
        setinvoiceNoRowData(list);
      } else {
        setError("You don't have privileges to view reconciliation");
      }
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };

  const totalInvoiceAmount =
    invoiceNoRowData &&
    invoiceNoRowData.reduce(
      (total, invoice) => total + invoice.invoiceAmount,
      0
    );

  const onGridReady = (params) => {
    setGridApi(params);
    loadLedgerListData();
  };

  useEffect(() => {
    loadLedgerListData();
  }, []);

  const ReconcilitationInput = () => {
    return (
      <>
        {(token?.scope?.includes("ROLE_FINANCE") ||
          token?.scope?.includes("ROLE_FINMGR") ||
          token?.scope?.includes("ROLE_SOPDIR")) && (
          <>
            <label className="pt-6 min-w-fit">Vendor</label>
            {/* <Select
                name="vouchertype"
                className=" min-w-[150px]"
                // value={(vouchertype && voucherTypeOptions.length > 0) && voucherTypeOptions.filter((list) => list.id === vouchertype)}
                onChange={handleChangeVendor}
                // options={voucherTypeOptions}
                styles={customStyles('', '', '0px')}
            /> */}
            <TextField
              className="w-[100%]"
              name="amount"
              value={vendor}
              size="small"
              onChange={(e) => setVendor(e.target.value)}
            />
            <label className="pt-6 min-w-fit">From Date </label>
            <div className="grid">
              <CustomDatePicker
                className="w-[150px] h-[20px]"
                format={"dd-MM-yyyy"}
                name={"fromDate"}
                value={fromDate}
                handleChange={handleFromDateChange}
                componentsProps={{
                  actionBar: { actions: ["clear"] },
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    InputLabelProps={{}}
                    {...params}
                    sx={{
                      backgroundColor: props.viewData && "#8080800f",
                    }}
                  />
                )}
              />
              <p className="text-red">{fromError && !fromDate && fromError}</p>
            </div>
            <label className="pt-6 min-w-fit">To Date </label>
            <div className="grid">
              <CustomDatePicker
                className="w-[150px] h-[20px]"
                format={"dd-MM-yyyy"}
                name={"toDate"}
                value={toDate}
                minDate={new Date(fromDate)}
                handleChange={handleToDateChange}
                componentsProps={{
                  actionBar: { actions: ["clear"] },
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    InputLabelProps={{}}
                    {...params}
                    sx={{
                      backgroundColor: props.viewData && "#8080800f",
                    }}
                  />
                )}
              />
            </div>
            {tabValue === 0 && (
              <>
                {/* <Tooltip title={"Add Reconciliation"}>
                        <Button
                            variant="contained"
                            color="warning"
                            style={{ marginBottom: '5px', fontWeight: 'bold', marginLeft: "3px" }}
                            onClick={handleAddReconcilitation}
                        >
                            <FuseSvgIcon className="text-xl">heroicons-solid:plus-circle</FuseSvgIcon>
                        </Button>
                    </Tooltip> */}
                <Tooltip title={"Print Reconciliation"}>
                  <Button
                    variant="contained"
                    color="warning"
                    style={{
                      marginBottom: "5px",
                      fontWeight: "bold",
                      marginLeft: "3px",
                    }}
                    onClick={handlePrintReconcilitation}
                  >
                    <FuseSvgIcon className="text-xl">
                      heroicons-outline:printer
                    </FuseSvgIcon>
                  </Button>
                </Tooltip>
              </>
            )}
            {tabValue === 1 && (
              <>
                {/* <Tooltip title={"Reconcile"}>
                        <Button
                            variant="contained"
                            color="warning"
                            style={{ marginBottom: '5px', fontWeight: 'bold', marginLeft: "3px" }}
                            onClick={handleReconcile}
                        >
                            <FuseSvgIcon className="text-xl">material-solid:supervised_user_circle</FuseSvgIcon>
                        </Button>
                    </Tooltip> */}
                <Tooltip title={"Upload Reconciliation"}>
                  <Button
                    variant="contained"
                    color="warning"
                    style={{
                      marginBottom: "5px",
                      fontWeight: "bold",
                      marginLeft: "3px",
                    }}
                    onClick={handleUploadReconcilitation}
                  >
                    <CloudUploadIcon fontSize={"medium"} />
                  </Button>
                </Tooltip>
              </>
            )}
            {tabValue === 2 && (
              <>
                <Tooltip title={"Refresh Reconcile"}>
                  <Button
                    variant="contained"
                    color="warning"
                    style={{
                      marginBottom: "5px",
                      fontWeight: "bold",
                      marginLeft: "3px",
                    }}
                    onClick={handleRefreshReconcile}
                  >
                    <FuseSvgIcon className="text-xl">
                      material-solid:refresh
                    </FuseSvgIcon>
                  </Button>
                </Tooltip>
                <Tooltip title={"Save Reconciliation"}>
                  <Button
                    variant="contained"
                    color="warning"
                    style={{
                      marginBottom: "5px",
                      fontWeight: "bold",
                      marginLeft: "3px",
                    }}
                    onClick={handleSaveReconcilition}
                  >
                    <FuseSvgIcon className="text-xl">
                      material-solid:save
                    </FuseSvgIcon>
                  </Button>
                </Tooltip>
              </>
            )}
          </>
        )}
      </>
    );
  };
  
  const options = {
    style: "decimal", // Other options: 'currency', 'percent', etc.
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };

  return (
    <>
      <ListPageHeader
        pageName={"Reconciliation"}
        componentName={"Reconciliation"}
        showPaginationDropdown={false}
        headerInputFields={ReconcilitationInput()}
        successMsg={successMsg}
        snackState={snackState}
        error={error}
      />
      {(token?.scope?.includes("ROLE_FINANCE") ||
        token?.scope?.includes("ROLE_FINMGR") ||
        token?.scope?.includes("ROLE_SOPDIR")) && (
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="secondary"
          textColor="inherit"
          sx={{ color: "yellow" }}
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: "w-full border-b-1" }}
        >
          <Tab label="Ledger List" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
          <Tab label="Statement of NOLTE KUCHEN" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
          <Tab label="Reconciliation " sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
        </Tabs>
      )}
      <div
        style={{
          height: tabValue === 0 ? "calc(100% - 160px)" : "0",
          display: tabValue === 0 ? "block" : "none",
        }}
      >
        <AgGridTable
          rowData={invoiceNoRowData}
          columnDefs={invoiceNoColumnDefs}
          onGridReady={onGridReady}
        />
        <Grid container spacing={2} className="mt-3">
          <Grid item xs={3}>
            <TextField
              className="w-[100%]"
              name="EUR"
              value="Total"
              size="small"
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              className="w-[100%]"
              name="amount"
              value={invoiceNoRowData && totalInvoiceAmount ? Number(totalInvoiceAmount).toLocaleString("en-US", options) : 0}
              size="small"
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
        </Grid>
      </div>

      {/* <div className={tabValue !== 1 ? 'hidden' : 'h-full'}> */}
      <div
        style={{
          height: tabValue === 1 ? "calc(100% - 160px)" : "0",
          display: tabValue === 1 ? "block" : "none",
        }}
      >
        <StatementOfNOLTE
          ref={childRef}
          // handleFormClose={handleFormClose}
          documentFile={documentFile}
          successMsg={handleSuccessMsg}
          fromDate={fromDate}
          toDate={toDate}
        />
      </div>

      {/* <div className={tabValue !== 2 ? 'hidden' : 'h-full'}> */}
      <div
        style={{
          height: tabValue === 2 ? "calc(100% - 160px)" : "0",
          display: tabValue === 2 ? "block" : "none",
        }}
      >
        <ReconciliationGrid tabValue={tabValue} ref={reconRef} />
      </div>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        onClose={handleFormClose}
        open={formOpen}
      >
        <Toolbar className="flex w-full justify-between">
          <Typography variant="subtitle1" color="inherit">
            Upload documents
          </Typography>
          <Button onClick={handleFormClose}>
            <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
          </Button>
        </Toolbar>
        <DialogContent>
          {!documentUpload ? (
            <Stack className="w-full mb-16">
              <Box
                className="flex justify-center items-center"
                sx={{
                  height: 180,
                  border: "1px dotted grey",
                }}
              >
                <CloudUploadIcon fontSize={"large"} />
                <Typography className="ml-12">Upload your Sheet</Typography>
                <Button
                  variant="contained"
                  component="label"
                  color="warning"
                  className="ml-12"
                >
                  <input
                    hidden
                    type="file"
                    onChange={(e) => handleDocumentChange(e)}
                  />
                  <Typography color="black">Browse</Typography>
                </Button>
              </Box>
            </Stack>
          ) : (
            <Stack className="w-full mb-16">
              <Box className="flex justify-between">
                <Grid className="flex">
                  <div>
                    <FileCopyIcon
                      fontSize={"large"}
                      color="warning"
                      className=" mt-20"
                    />
                  </div>
                  <div>
                    <Typography fontSize={"large"} className="ml-12 mt-20">
                      {documentUpload}
                    </Typography>
                  </div>
                </Grid>
                <Grid></Grid>
              </Box>
            </Stack>
          )}
        </DialogContent>
        {documentUpload && (
          <DialogActions>
            <Button
              variant="contained"
              color="warning"
              style={{
                marginBottom: "5px",
                fontWeight: "bold",
                marginLeft: "3px",
              }}
              onClick={importExcel}
              disabled={uploadDisabled}
            >
              <CloudUploadIcon fontSize={"medium"} />
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </>
  );
};
export default Reconciliation;
